import { render, staticRenderFns } from "./BiView.vue?vue&type=template&id=50ab8f7e&scoped=true"
import script from "./BiView.vue?vue&type=script&lang=js"
export * from "./BiView.vue?vue&type=script&lang=js"
import style0 from "./BiView.vue?vue&type=style&index=0&id=50ab8f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab8f7e",
  null
  
)

export default component.exports